import request from '@/router/axios';

export function fetchList(query) {
  return request({
    url: '/system/role/page',
    method: 'get',
    params: query,
  });
}

export function deptRoleList() {
  return request({
    url: '/system/role/list',
    method: 'get',
  });
}

export function getObj(id) {
  return request({
    url: '/system/role/' + id,
    method: 'get',
  });
}

export function addObj(obj) {
  return request({
    url: '/system/role',
    method: 'post',
    data: obj,
  });
}

export function putObj(obj) {
  return request({
    url: '/system/role',
    method: 'put',
    data: obj,
  });
}

export function delObj(id) {
  return request({
    url: '/system/role/' + id,
    method: 'delete',
  });
}

export function permissionUpd(roleId, menuIds) {
  return request({
    url: '/system/role/menu',
    method: 'put',
    data: {
      roleId: roleId,
      menuIds: menuIds,
    },
  });
}

export function fetchRoleTree(roleName, data) {
  return request({
    url: '/system/menu/tree/' + roleName,
    method: 'get',
    params: data,
  });
}
